import { createSlice } from '@reduxjs/toolkit';
import { apiContainer } from '@vlabs/api-bindings';

export const initialState = {
  state: undefined,
  availableAnalytics: [],
  streams: [],
  byId: [],
  groups: [],
  groupOptions: [],
  streamOptions: [],
  filters: {},
  filterCounts: 0,
  pageIndex: 0,
  pageSize: 25,
  pageSizeOptions: [10, 25, 50, 100],
};

const store = createSlice({
  name: 'videoAnalytics',
  initialState,
  reducers: {
    setAvailableAnalytics(state, { payload: { analytics } }) {
      // Удаляем 'human_tracking' из списка, т.к. это легаси аналитика, которая сейчас не используется
      analytics = analytics.filter(({ analytic_name }) => analytic_name !== 'human_tracking');
      state.availableAnalytics = analytics;
      state.state = 'loaded';
    },

    setAnalyticStreams(state, { payload: streams }) {
      state.streams = streams;
      state.byId = [];
      streams.forEach((stream) => {
        const { stream_id } = stream;
        state.byId[stream_id] = stream;
      });
      state.streamOptions = streams.map(({ stream_id, name } = {}) => ({
        value: stream_id,
        label: name || stream_id,
        streamId: stream_id,
      }));
    },

    setGroups(state, { payload: groups }) {
      state.groups = groups;
      state.groupOptions = groups.map(({ group_id, group_name } = {}) => ({
        value: group_name,
        label: group_name,
        groupId: group_id,
      }));
    },

    setFilters(state, { payload: { filters = {} } }) {
      state.filters = filters;
      state.pageIndex = 0;
    },
    setFilterCounts(state, { payload }) {
      state.filterCounts = payload;
    },
    setPageIndex(state, { payload: { pageIndex } = {} }) {
      if (pageIndex !== undefined) state.pageIndex = pageIndex;
    },
    setPageSize(state, { payload: { pageSize } = {} }) {
      if (pageSize !== undefined) state.pageSize = pageSize;
    },
  },
});

export default store.reducer;

export const {
  setAvailableAnalytics,
  setAnalyticStreams,
  setGroups,
  setFilters,
  setFilterCounts,
  setPageIndex,
  setPageSize,
} = store.actions;

export const fetchAvailableAnalytics = async (dispatch) => {
  try {
    const { data } = await apiContainer.lunaClient.analytics.getAll();
    dispatch(setAvailableAnalytics(data));
  } catch (error) {
    dispatch(setAvailableAnalytics({ analytics: [] }));
    throw error;
  }
};

export const fetchAnalyticStreams = async (dispatch) => {
  try {
    const data = await apiContainer.lunaClient.streams.getAll();
    dispatch(setAnalyticStreams(data));
  } catch (error) {
    dispatch(setAnalyticStreams([]));
    throw error;
  }
};

export const fetchGroups = async (dispatch) => {
  try {
    const data = await apiContainer.lunaClient.groups.getAll();
    dispatch(setGroups(data));
  } catch (error) {
    dispatch(setGroups([]));
    throw error;
  }
};

export const init = (dispatch) => {
  dispatch(fetchAvailableAnalytics);
  dispatch(fetchAnalyticStreams);
  dispatch(fetchGroups);
};

export const updateFilters = (params) => async (dispatch) => {
  dispatch(setFilters(params));
};
